<template>
  <el-row class="">
    <div>
      <img src="../assets/banner/childLogo.png" style="width:100%;height:100%">
    </div>
  </el-row>
</template>

<script>
export default {
  name: 'ChildLogo'
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ChildLogo.vue